import apiFetch from '../apiFetch'

export default function (token, typeId) {
  const queryParamsArray = [
    `typeId=${typeId}`
  ]
  const queryParams = queryParamsArray.reduce(
    (result, query, idx) => result + (query ? (result ? `&${query}` : `?${query}`) : '')
    , ''
  )
  return apiFetch({ endPoint: `CampaignType/Recover${queryParams}`, method: 'POST', body: null, token: token })
}
